module.exports = __webpack_public_path__ + "src/assets/games/9/165.jpg";